module.exports = __webpack_public_path__ + "img/xiazai.3b277e6c.png";